<template>
    <div>
      <svg width="64px" height="64px">
        <circle cx="31.5px" cy="31.5px" r="31.5px" fill="#2289E9" />
        <text x="50%" y="50%" fill="white" text-anchor="middle" dominant-baseline="middle">
          {{ inputText }}
        </text>      
      </svg>
    </div>
  </template>
  
  <script lang="ts">
  import { Vue, Component, Prop } from 'vue-property-decorator';
  
  @Component
  export default class CircleComponent extends Vue {
    @Prop() inputText!: string; 
  }
  </script>
  